import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import * as moment from 'moment';

@Pipe({
  name: 'localizedDurata',
  pure: false
})
export class LocalizedDurataPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: any): any {
   /* const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);
    const datamoment = moment(value);
    return datePipe.transform(datamoment.toDate(), pattern);
    */
    // return datePipe.transform(value, pattern);
    if (value > 0 && value / 60 < 1) {
        return value + ' ' + this.translate.instant('minuti') ;
      } else {
        const ore = Math.floor(value / 60);
        const minuti = value % 60;
        const labelOre = ore > 1 ? 'ore' : 'ora';
        const labelMinuti = minuti > 1 ? 'minuti' : 'minuto';
        if (minuti === 0) {
            return ore + ' ' + this.translate.instant(labelOre);
        } else {
            return ore + ' ' + this.translate.instant(labelOre) + ' ' + minuti + ' ' + this.translate.instant(labelMinuti);
        }
      }

  }
}
